package ru.villawonka.app.presentation.design.components

enum class AppButtonType {
    PRIMARY,
    SECONDARY,
    TERTIARY
}